import { c as _c } from "react/compiler-runtime";
import { useDispatch, useSelector } from "react-redux";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import GroupItem from "./item/GroupItem";
import { selectActiveGroupId, setActiveGroupId } from "@/store/groupSlice";
export default function GroupItems(t0) {
  const $ = _c(11);
  const {
    groups
  } = t0;
  const activeGroupId = useSelector(selectActiveGroupId);
  const dispatch = useDispatch();
  let t1;
  if ($[0] !== dispatch) {
    t1 = groupId => {
      dispatch(setActiveGroupId(groupId));
    };
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onActiveGroupId = t1;
  let t2;
  if ($[2] !== activeGroupId || $[3] !== groups || $[4] !== onActiveGroupId) {
    let t3;
    if ($[6] !== activeGroupId || $[7] !== onActiveGroupId) {
      t3 = group => <GroupItem key={group.id} group={group} activeGroupId={activeGroupId} onActiveGroupId={onActiveGroupId} />;
      $[6] = activeGroupId;
      $[7] = onActiveGroupId;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = groups.map(t3);
    $[2] = activeGroupId;
    $[3] = groups;
    $[4] = onActiveGroupId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <div className="tw-space-y-4">{t2}</div>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}